var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEditicon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_903_5387)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.24219 16.8751H3.75C3.58424 16.8751 3.42527 16.8092 3.30806 16.692C3.19085 16.5748 3.125 16.4158 3.125 16.2501V12.7579C3.12472 12.6767 3.14044 12.5963 3.17128 12.5212C3.20211 12.4461 3.24745 12.3779 3.30469 12.3204L12.6797 2.94537C12.7378 2.88631 12.8072 2.83942 12.8836 2.80741C12.9601 2.7754 13.0421 2.75891 13.125 2.75891C13.2079 2.75891 13.2899 2.7754 13.3664 2.80741C13.4428 2.83942 13.5122 2.88631 13.5703 2.94537L17.0547 6.42974C17.1137 6.4879 17.1606 6.55722 17.1927 6.63367C17.2247 6.71012 17.2411 6.79217 17.2411 6.87505C17.2411 6.95794 17.2247 7.03999 17.1927 7.11644C17.1606 7.19289 17.1137 7.26221 17.0547 7.32037L7.67969 16.6954C7.62216 16.7526 7.55391 16.7979 7.47884 16.8288C7.40376 16.8596 7.32335 16.8753 7.24219 16.8751V16.8751Z",
    stroke: "#27AE60",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.625 5L15 9.375",
    stroke: "#27AE60",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_903_5387"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditicon);
export default __webpack_public_path__ + "static/media/editicon.b32583d556ffeec414cca2e74e11ea17.svg";
export { ForwardRef as ReactComponent };